import { FormType } from '@gearbelt/global';

import { AWAFormPage } from '../form';

export function AWAInspectionPage() {
  return <AWAFormPage formType={FormType.InspectionForm} />;
}
